import { transactionPayoutChoices } from '@/components/global/options/selectOptions.jsx';
import { useTranslate } from 'react-admin';

const TransactionPayoutField = ({ record }) => {
    const translate = useTranslate();
    const value = record?.payout?.type;
    if (!value) return null;

    const payoutType = transactionPayoutChoices(translate).find(s => s.id === value);
    if (!payoutType) return <span>{translate('resources.transaction.fields.unknown')}</span>;

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {payoutType.icon && (
                <div className='payout-type-icon' style={{ marginRight: '8px', height: '20px' }}>
                    {payoutType.icon}
                </div>
            )}
            <span className='device-state-field-name' style={{ whiteSpace: 'nowrap' }}>
                {payoutType.name}
            </span>
        </div>
    );
};

export default TransactionPayoutField;
